export const FALLBACK = {
  VERTICAL_BANNER: "vertical_banner",
  HORIZONTAL_BANNER: "horizontal_banner",
  IMAGE: "image",
} as const;
